"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnitStyled = exports.ValueStyled = exports.ValueWrapperMultipleStyled = exports.ValueWrapperStyled = exports.TextValuesMultipleStyled = exports.TextValuesStyled = exports.ToggleInputStyled = exports.ToggleStyled = exports.ToggleWrapperMultipleStyled = exports.ToggleWrapperStyled = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Color_enum_1 = require("../../constants/Color.enum");
const TOGGLE_DEFAULT_WIDTH = 336;
const TOGGLE_SMALL_WIDTH = 144;
const TOGGLE_HEIGHT = 36;
exports.ToggleWrapperStyled = styled_components_1.default.label `
    cursor: ${(props) => (props.disabled ? 'initial' : 'pointer')};
    position: relative;
    display: inline-block;
    width: 100%;
    max-width: ${({ small }) => (small ? TOGGLE_SMALL_WIDTH : TOGGLE_DEFAULT_WIDTH)}px;
    height: ${TOGGLE_HEIGHT}px;
    background-color: ${Color_enum_1.Color.Background};
    border-radius: 50px;
    opacity: ${(props) => (props.disabled ? 0.3 : 'initial')};
`;
exports.ToggleWrapperMultipleStyled = styled_components_1.default.label `
    cursor: ${(props) => (props.disabled ? 'initial' : 'pointer')};
    position: relative;
    display: inline-block;
    width: ${({ full }) => (full ? '100%' : 'auto')};
    height: ${TOGGLE_HEIGHT}px;
    background-color: ${Color_enum_1.Color.Background};
    opacity: ${(props) => (props.disabled ? 0.3 : 'initial')};
    border-radius: 50px;
`;
exports.ToggleStyled = styled_components_1.default.span `
    position: absolute;
    border-radius: 100px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: 0.4s;

    &::before {
        border-radius: 100px;
        position: absolute;
        content: '';
        height: ${TOGGLE_HEIGHT}px;
        width: 50%;
        border: 1px solid ${Color_enum_1.Color.Variant_1};
        background-color: ${Color_enum_1.Color.Surface};
        transition: 0.4s;
    }
`;
exports.ToggleInputStyled = styled_components_1.default.input.attrs({ type: 'checkbox', tabindex: '-1' }) `
    opacity: 0;
    width: 0;
    height: 0;
    pointer-events: none;

    &:checked + ${exports.ToggleStyled}:before {
        transform: translateX(100%);
    }
`;
exports.TextValuesStyled = styled_components_1.default.div `
    display: flex;
    width: 100%;
    justify-content: space-between;
    height: ${TOGGLE_HEIGHT}px;
    position: absolute;
    z-index: 1;
    pointer-events: none;
`;
exports.TextValuesMultipleStyled = styled_components_1.default.div `
    display: grid;
    grid-auto-flow: column;
    height: ${TOGGLE_HEIGHT}px;
    z-index: 1;
`;
exports.ValueWrapperStyled = styled_components_1.default.div `
    display: flex;
    justify-content: center;
    width: 50%;
    align-items: center;
    font-weight: ${(props) => (props.selected ? 500 : 300)};
`;
exports.ValueWrapperMultipleStyled = styled_components_1.default.div `
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: ${(props) => (props.selected ? 500 : 300)};
    border: 1px solid ${(props) => (props.selected ? 'rgb(217, 217, 217)' : 'transparent')};
    background-color: ${(props) => (props.selected ? 'rgb(255, 255, 255)' : 'transparent')};
    border-radius: 50px;
    padding: 0 24px;
`;
exports.ValueStyled = styled_components_1.default.div `
    font-size: 12px;
    line-height: 15px;
    color: ${Color_enum_1.Color.Primary};
`;
exports.UnitStyled = styled_components_1.default.div `
    font-size: 10px;
    line-height: 12px;
    color: ${Color_enum_1.Color.Secondary};
`;
